import { render, staticRenderFns } from "./ActivityImage.vue?vue&type=template&id=5f20f6ea&scoped=true"
import script from "./ActivityImage.vue?vue&type=script&lang=ts"
export * from "./ActivityImage.vue?vue&type=script&lang=ts"
import style0 from "./ActivityImage.vue?vue&type=style&index=0&id=5f20f6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20f6ea",
  null
  
)

export default component.exports